import Hero from './Hero';
import AboutUs from './AboutUs';
import Gallery from './Gallery';

function App() {
  return (
    <main className="App">
      <Hero/>
      <AboutUs/>
      <Gallery/>
    </main>
  );
}

export default App;
